export default __webpack_public_path__ + "static/media/peer-through-media.c9844e90.png";